import { apiSlice } from './apiSlice';
import { PAYPHONE_URL } from '../constants';

export const payphoneApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPayphoneConfig: builder.query({
            query: (companyId) => ({
                url: `${PAYPHONE_URL}/config`,
                ...(companyId ? { params: { companyId } } : {}),
            }),
            keepUnusedDataFor: 5,
        }),
        confirmPayphonePayment: builder.mutation({
            query: ({ id, clientTransactionId, orderId, companyRuc }) => ({
                url: `${PAYPHONE_URL}/confirm`,
                method: 'POST',
                body: { id, clientTransactionId, orderId, companyRuc },
            }),
        }),
    }),
});

export const { useGetPayphoneConfigQuery, useConfirmPayphonePaymentMutation } = payphoneApiSlice;
